<template>
  <ConversationSimulateTest />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
